export const fontImports = [
    {
        family: 'GoogleSans',
        folder: 'delonghi',
        variants: [
            {name: 'Regular', weight: 400},
            {name: 'Medium', weight: 500},
            {name: 'SemiBold', weight: 600},
            {name: 'Bold', weight: 700},
        ],
    },
    {
        family: 'Google Sans Flex',
        folder: 'delonghi',
        // The file name differs from the font family name
        fileName: 'GoogleSansFlex',
        variants: [{name: '', weight: '100 900'}],
        options: {
            style: 'normal',
            unicodeRange:
                'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
            preload: true,
        },
    },
    {
        family: 'DeLonghiSerif',
        folder: 'delonghi',
        variants: [
            {name: 'Light', weight: 300},
            {name: 'Regular', weight: 400},
            {name: 'Medium', weight: 500},
        ],
    },
    {
        family: 'NotoSans',
        folder: 'global',
        variants: [
            {name: 'Regular', weight: 400},
            {name: 'Bold', weight: 700},
        ],
    },
]
